import {useSelector} from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useMemo, useState } from "react";
import { CurriculaService } from "../../globals/services/curricula.service";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { msFileTypes } from "../../globals/helpers/consts";
import { UserListInCurriculumEntity } from "../users/UserListInCurriculum";
import msgIcon from "../../assets/images/msgIcon.svg";

export const CurriculumEdit = ({ item, action }) => {
  const { me } = useSelector((state) => state.auth);
  const curriculaService = CurriculaService();
  const history = useHistory();

  const initialState = {
    _id: item?._id,
    sfSeminarId: item?.sfSeminarId,
    entityType: item?.entityType,
    entityTitle: item?.entityTitle,
    entityStatus: item?.entityStatus,
    entityStartDate: item?.entityStartDate,
    entityEndDate: item?.entityEndDate,
    entityTemplatesData: item?.entityTemplatesData || [],
    entityParticipants: item?.entityParticipants || [],
    entityDescription: item?.entityDescription,
    entityTeams: item?.entityTeams || [],
    modifiedBy: me?._id,
    modified: moment().format("YYYY-MM-DD"),
    templatesList: item?.templatesList || [],
    templateCurrentId: item.entityTemplatesData.length > 0 ? item.entityTemplatesData[0]._id : null,
    curriculaUsers: item?.entityUsersData || [],
    thumbnail: item?.thumbnail,
    removeCurriculaUsers: null,
  };

  const [state, setState] = useState(initialState);
  const [validImage, setValidImage] = useState(null);
  const [thumbPreview, setThumbPreview] = useState(null);

  const users = useMemo(() => {
    let users = [];
    state?.entityParticipants?.forEach((participant) => {
      if (participant.Status__c !== "Canceled" && participant.Contact__r) {
        users.push({
          _id: participant.Contact__r?.HN_UserId__c,
          firstName: participant.Contact__r?.FirstName,
          lastName: participant.Contact__r?.LastName,
          fullName: participant.Contact__r?.Name || participant.Contact__r?.FirstName + " " + participant.Contact__r?.LastName,
          email: participant.Contact__r.Email,
          status: participant?.Status__c,
          entityRole: "participant",
        });
      }
    });
    state?.entityTeams?.forEach((teamMember) => {
      if (teamMember.Name__r) {
        users.push({
          _id: teamMember.Name__r?.HN_UserId__c,
          firstName: teamMember.Name__r?.FirstName,
          lastName: teamMember.Name__r?.LastName,
          fullName: teamMember.Name__r?.Name || teamMember.Name__r?.FirstName + " " + teamMember.Name__r?.LastName,
          email: teamMember.Name__r?.Email,
          entityRole: teamMember?.Type__c || "Team Member",
        });
      }
    });
    return users;
  }, [state?.entityParticipants, state?.entityTeams]);

  const handleForm = (prop) => {
    setState({
      ...state,
      ...prop,
    });

    if (prop.thumbnail && prop.thumbnail.type.includes("image")) {
      setThumbPreview(URL.createObjectURL(prop.thumbnail));
      setValidImage("valid");
    } else if (prop.thumbnail) {
      setValidImage("invalid");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    action(e);
    if (state._id) {
      curriculaService.updateCurriculum(state);
    }
  };

  const goToNotification = () => {
    history.push({
      pathname: "/notification",
      state: { item: state },
    });
  };

  return (
    <div key={state._id}>
      <h2>{state._id ? "Change Curriculum Properties" : "Create Curriculum Form"}</h2>

      <Form>
        <Row className="d-flex justify-content-between">
          <Col className="px-2 col-md-5">
            <Row className="mt-2">
              <Col className="px-2 col-md-11">
                <FormGroup>
                  <h5 className="mt-4">
                    <Label htmlFor="_title">Title</Label>
                  </h5>
                  <Input
                    id="entityTitle"
                    name="entityTitle"
                    placeholder="with a placeholder"
                    type="text"
                    onChange={(e) => handleForm({ entityTitle: e.target.value })}
                    value={state.entityTitle ? state.entityTitle : ""}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="px-2 col-md-6">
                <FormGroup className="mb-3 mt-3 mt-lg-0">
                  <h5 className="mt-4">
                    <Label htmlFor="_templates">Template</Label>
                  </h5>
                  <select
                    className="selectInput"
                    id="_templates"
                    value={state.templateCurrentId ? state.templateCurrentId : ""}
                    onChange={(e) => handleForm({ templateCurrentId: e.target.value })}
                  >
                    {state.templatesList && state.templatesList.length > 0
                      ? state.templatesList.map((template, index) => {
                          return (
                            <option key={index} value={template._id}>
                              {template.title}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </FormGroup>
              </Col>
              <Col className="px-2 col-md-4">
                <FormGroup className="mb-3 mt-3 mt-lg-0">
                  <h5 className="mt-4">
                    <Label htmlFor="_status">Status</Label>
                  </h5>
                  <select
                    className="selectInput"
                    id="entityStatus"
                    value={state.entityStatus ? state.entityStatus : ""}
                    onChange={(e) => handleForm({ entityStatus: e.target.value })}
                  >
                    <option value=""></option>
                    <option value="Live">Live</option>
                    <option value="Hidden">Hidden</option>
                    <option value="Draft">Draft</option>
                  </select>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="px-2 col-md-11">
                <FormGroup>
                  <h5 className="mt-4">
                    <Label htmlFor="_description">Description</Label>
                  </h5>
                  <Input
                    id="entityDescription"
                    name="entityDescription"
                    type="textarea"
                    rows="5"
                    onChange={(e) => handleForm({ entityDescription: e.target.value })}
                    value={state.entityDescription ? state.entityDescription : ""}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="px-2 col-md-11">
                <FormGroup>
                  <Label htmlFor="formFile" className="form-label">
                    Select File For Upload
                  </Label>
                  <Input
                    accept={"application/*,image/*,video/*,audio/*," + msFileTypes.join()}
                    onChange={(e) => {
                      handleForm({ thumbnail: e.target.files[0] });
                    }}
                    className="form-control"
                    type="file"
                    id="formFile"
                  />
                  {validImage === "invalid" ? <div className="invalid-feedback d-block">Please select a valid image file</div> : null}
                  {state.thumbnail ? <img className={"previewThumb"} alt={"alt"} src={thumbPreview !== null ? thumbPreview : state.thumbnail} /> : null}
                </FormGroup>
              </Col>
            </Row>

            {validImage !== "invalid" || validImage === null ? (
              <Row className="mt-2">
                <Col className="px-2 col-12 col-md-3">
                  <Button onClick={(e) => handleSubmit(e)}>Save Changes</Button>
                </Col>
              </Row>
            ) : null}
          </Col>

          <Col className="ml-auto col-md-5 px-3">
            <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
              <Label htmlFor="description">Users Management</Label>
              <UserListInCurriculumEntity users={users} entity={state._id} entityType={"curriculum"} />
            </FormGroup>
          </Col>
        </Row>
      </Form>
      <div className="msgDialogBtn">
        <button className="msgDialogBtn" onClick={goToNotification}>
          <img src={msgIcon} alt="Message Icon" />
        </button>
      </div>
    </div>
  );
};